import { render, staticRenderFns } from "./CardBriefJoin.vue?vue&type=template&id=7e928677&scoped=true&"
import script from "./CardBriefJoin.vue?vue&type=script&lang=js&"
export * from "./CardBriefJoin.vue?vue&type=script&lang=js&"
import style0 from "./CardBriefJoin.vue?vue&type=style&index=0&id=7e928677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e928677",
  null
  
)

export default component.exports